import type { PeakRange } from './audioTrackConfig';
import { getPeaksFromUint8Array } from '../components/Common/Timeline/Audio/audioUtils';
import type { PeaksManagerOps } from './peaksManagerOps';
import { invariant } from '@mimir/common/util/invariant';
import type { Observable, ObservableState } from '@mimir/common/util/observable';

/**
 * This class is a simple implementation of PeaksManagerOps that
 * relies on external injection of the peaks.
 */
export class BasicPeaksManager implements PeaksManagerOps {

  private peaks: Uint8Array[];

  constructor(
    private nPeaksPerSecond: number,
    peaks: Uint8Array[],
    private peakCount: ObservableState<number>,
  ) {
    this.peaks = peaks;
    this.peakCount.value = peaks.length === 0 ? 0 : peaks[0].length;
  }

  getPeakCount(): Observable<number> {
    return this.peakCount.getObservable();
  }


  setPeaks(peaks: Uint8Array[]) {
    if (peaks.length !== this.peaks.length) {
      throw new Error(`Expected ${this.peaks.length} peak arrays but got ${peaks.length}`);
    }
    this.peaks = peaks;
    this.peakCount.value = peaks.length === 0 ? 0 : peaks[0].byteLength;
  }


  /**
   * We have one peaks series per audio track since all channels are
   * processed individually.
   */
  public getPeakSeriesCount(_streamIndex: number): number {
    return 1;
  }


  public getPeaks(
    audioTrackIndex: number,
    channel: number,
    range: PeakRange,
    width: number,
  ): number[] {
    invariant(channel === 0, () => `Expected channel 0 but got ${channel}`);
    const peakBuffer = this.peaks[audioTrackIndex];
    return getPeaksFromUint8Array(peakBuffer, this.nPeaksPerSecond, range, width);
  }

}
